var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-select-queslib" },
    [
      _c(
        "div",
        { staticClass: "clearfix font-size-14" },
        [
          _c("catalogDropdown", {
            staticClass: "pull-left mr12",
            attrs: {
              data: _vm.datasCatalog,
              dropToolTip: _vm.$t("pc_biz_lbl_selectcatalogforsearch", [
                _vm.$t("pc_biz_ote_lbl_quesbank"),
              ]),
              catalogId: _vm.datasSearch.catalogId,
              catalogName: _vm.datasSearch.catalogName,
            },
            on: {
              "update:catalogId": function ($event) {
                return _vm.$set(_vm.datasSearch, "catalogId", $event)
              },
              "update:catalog-id": function ($event) {
                return _vm.$set(_vm.datasSearch, "catalogId", $event)
              },
              "update:catalogName": function ($event) {
                return _vm.$set(_vm.datasSearch, "catalogName", $event)
              },
              "update:catalog-name": function ($event) {
                return _vm.$set(_vm.datasSearch, "catalogName", $event)
              },
              change: _vm.selectCatalog,
            },
          }),
          _c("yxt-input", {
            staticClass: "pull-left",
            staticStyle: { width: "240px" },
            attrs: {
              placeholder: _vm.$t("pc_biz_lbl_inputnameforsearch", [
                _vm.$t("pc_biz_ote_lbl_quesbankname"),
              ]),
              searchable: "",
              maxlength: "50",
            },
            on: { search: _vm.nameSearch },
            model: {
              value: _vm.datasSearch.name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.datasSearch,
                  "name",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "datasSearch.name",
            },
          }),
        ],
        1
      ),
      _c(
        "yxt-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: _vm.refTable,
          staticClass: "mt16",
          attrs: {
            height: _vm.tableHeight,
            data: _vm.datasList,
            "default-sort": { prop: "updateTime", order: "desc" },
          },
          on: {
            "sort-change": _vm.sortChange,
            "select-all": _vm.selectAll,
            select: _vm.select,
          },
        },
        [
          _c("yxt-table-column", {
            attrs: {
              selectable: _vm.selectable,
              type: "selection",
              "show-overflow-tooltip": false,
              width: "38",
              align: "right",
              "clear-padding": "left-right",
            },
          }),
          _c("yxt-table-column", {
            attrs: {
              label: _vm.$t("pc_biz_ote_lbl_quesbankname"),
              "show-overflow-tooltip": false,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "yxt-tooltip",
                      {
                        staticClass: "ellipsis",
                        attrs: {
                          "open-filter": "",
                          "max-width": 300,
                          effect: "dark",
                          content: scope.row.name,
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "color-primary-6 hand v-mid",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.goQuesLibPreview(scope.row.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.name) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                    scope.row.secrecy === 1
                      ? _c(
                          "yxt-tag",
                          {
                            key: "保密",
                            staticClass: "ml8 v-mid",
                            attrs: { type: "warning", size: "mini" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("pc_ote_tip_secrecy")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("yxt-table-column", {
            attrs: {
              label: _vm.$t("pc_biz_ote_lbl_queslibcatalog"),
              prop: "catalogName",
              width: "140",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt16 clearfix" },
        [
          _c("yxt-pagination", {
            staticClass: "pull-right",
            attrs: {
              "page-size": _vm.datasSearch.limit,
              total: _vm.count,
              "current-page": _vm.page,
              layout: "total, prev, pager, next",
            },
            on: {
              "current-change": _vm.pageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          ref: "queslibViewDrawer",
          attrs: {
            size: "640px",
            title: _vm.$t("pc_biz_ote_lbl_queslibview"),
            visible: _vm.queslibDetailData.dialogVisible,
            "before-close": _vm.handleClose,
            destroyOnClose: true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.queslibDetailData, "dialogVisible", $event)
            },
          },
        },
        [_c("ques-lib-view", { attrs: { id: _vm.queslibDetailData.id } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }